import React from 'react';
import { useDispatch } from 'react-redux';
import { openModal } from '@/Store/Slices/ModalSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

const MultipleHideMerchants = ({checked}) => {
  const dispatch = useDispatch();

  const handleMultipleAction = () => {
    dispatch(openModal({
      modalType: 'multiple-coupon-modal',
      modalProps: {
        ids: checked,
        url: 'public.merchants.multi.hide',
        text: 'Do you want to hide selected merchants?',
      }
    }));
  }

  return (
    <button onClick={handleMultipleAction} className={'mr-3'} data-tip="Multiple hide merchants" >
      <FontAwesomeIcon
        rotation={180}
        color={'gray'}
        size={'lg'}
        icon={solid('eye-slash')}/>
    </button>
  );
};

export default MultipleHideMerchants;
